function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useState } from "react";

/**
 * Determines if a menu should flip its placement to above an
 * element if there is not enough vertical space below to
 * render the entire menu.
 *
 * To be used with ASelect and other components that use AMenu
 * in a dropdown sort of way.
 */

var useMenuSpacing = function useMenuSpacing(surfaceRef, menuRef, maxHeight) {
  var _menuRef$current;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    menuSpace = _useState2[0],
    setMenuSpace = _useState2[1];
  var checkMenuSpacing = useCallback(function () {
    var _surfaceRef$current;
    var inputBottom = surfaceRef === null || surfaceRef === void 0 ? void 0 : (_surfaceRef$current = surfaceRef.current) === null || _surfaceRef$current === void 0 ? void 0 : _surfaceRef$current.getBoundingClientRect().bottom,
      verticalSpace = inputBottom ? window.innerHeight - inputBottom - 10 : null;
    verticalSpace && setMenuSpace(verticalSpace);
  }, [surfaceRef]);
  var menuHeight = (menuRef === null || menuRef === void 0 ? void 0 : (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.clientHeight) || 0;
  var menuPlacement = menuHeight < menuSpace || maxHeight && menuSpace > parseInt(maxHeight) ? "bottom" : "top";
  return {
    checkMenuSpacing: checkMenuSpacing,
    menuPlacement: menuPlacement
  };
};
export default useMenuSpacing;